import React from "react";
import PropTypes from "prop-types";

import {
  CardBox,
  CardTitle,
  Centered,
  InformationText,
  SplitPanel
} from "../CardsStyled";
import { useTranslate } from "hooks/translation-hooks";
import ToolsIcon from "../../Icons/ToolsIcon";

const contractorArrivedCategory = "contractor_arrived";

export const ContractorArrived = ({ providerName }) => {
  const t = useTranslate();
  return (
    <CardBox data-category={contractorArrivedCategory}>
      <SplitPanel>
        <Centered>
          <ToolsIcon />
        </Centered>
        <Centered>
          <CardTitle>{t("contractor_arrived_card-title")}</CardTitle>
        </Centered>
        <InformationText>
          {t("contractor_arrived_card-text_1")} {providerName}{" "}
          {t("contractor_arrived_card-text_2")}{" "}
        </InformationText>
      </SplitPanel>
    </CardBox>
  );
};

ContractorArrived.propTypes = {
  providerName: PropTypes.string,
  isCurrent: PropTypes.bool
};

ContractorArrived.defaultProps = {
  providerName: "AXA partners",
  isCurrent: false
};

export default ContractorArrived;
